<template>
    <v-checkbox
        :label="choice.value+' ('+profileCount+')'"
        :value="choice.id"
        v-model="selectedChoices"
        multiple
        color="secondary"
        hide-details="auto"
    ></v-checkbox>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "FacetFilter",
    props: {
        facet: {
            type: Object,
            required: true,
        },
        choice: {
            type: Object,
            required: true,
        },
    },
    computed: {
        selectedChoices: {
            get () { return this.filters.facetChoices[this.facet.id]; },
            set (value) { this.$store.dispatch('updateFacetFilter', {facet: this.facet, choices: value}) },
        },
        profileCount () {
            return this.profiles.filter(profile => profile.facetChoices.findIndex(choice => choice.id === this.choice.id) !== -1).length;
        },
        ...mapState({
            filters: state => state.profile.filters,
            profiles: state => state.profile.profiles,
        }),
    },
}
</script>

<style scoped>

</style>
